import React from "react";

// Capa 1 del filtro reutilizable: SOLO el diseño (título, X, línea con punto,
// tarjeta de campos a la izquierda y columnas opcionales a la derecha).
// Úsalo directo cuando un filtro sea demasiado específico para FiltroPanel.
// Fecha de creación: 2026-09-15 — Autor: IA (Claude)
const FiltroPanelLayout = ({ titulo = "Filtro", onCerrar, tarjeta, columnas = [] }) => {
  const columnasVisibles = columnas.filter(Boolean);
  return (
    <div className="filtro-panel" role="dialog" aria-label={titulo}>
      <div className="filtro-panel-header">
        <span className="filtro-panel-titulo">{titulo}</span>
        {onCerrar && (
          <button type="button" className="filtro-panel-cerrar" onClick={onCerrar} aria-label="Cerrar filtro">
            X
          </button>
        )}
      </div>
      <div className="filtro-panel-linea">
        <span className="filtro-panel-linea-punto" />
      </div>
      <div className="filtro-panel-cuerpo">
        <div className="filtro-panel-tarjeta">{tarjeta}</div>
        {columnasVisibles.length > 0 && (
          <div className="filtro-panel-columnas">
            {columnasVisibles.map((columna, index) => (
              <div key={index} className="filtro-panel-columna">
                {columna}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FiltroPanelLayout;
